import { useState, useCallback } from 'react';
import axiosInstance from '../axios/axiosInstance';

export function useEquipament() {
  const [loading, setLoading] = useState(false);

  const [result, setResult] = useState('');

  const pathsCall = useCallback(async (tag) => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(`maquinario/${tag}`);
      setResult(res.data);
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        return setResult({ error: 'ERR_NETWORK' });
      }
      return setResult({ error: 'Não encontrado' });
    }
    setLoading(false);
  }, []);

  return { result, pathsCall, loading };
}
